export const PAGE_HEADER_ID = 'page-header'
